import { render, staticRenderFns } from "./qItem.vue?vue&type=template&id=146d3ff2&scoped=true&"
import script from "./qItem.vue?vue&type=script&lang=js&"
export * from "./qItem.vue?vue&type=script&lang=js&"
import style0 from "./qItem.vue?vue&type=style&index=0&id=146d3ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146d3ff2",
  null
  
)

export default component.exports